import Storage from "@/services/storage";
import { StorageConstants } from "@/enums/storage.enum";
import { LocationDeliveryTimeType } from "@/types/dashboard/locationDeliveryTime";
import { LocationDeliveryTimeInterface } from "@/interface/dashboard";

class LocationDeliveryTime implements LocationDeliveryTimeInterface {
  list: Array<LocationDeliveryTimeType> = [];

  constructor(data?: Array<LocationDeliveryTimeType>) {
    if (data) {
      this.list = data;
    }
  }

  toChartDate(): Array<any> {
    const locations = Storage.get(StorageConstants.LOCATIONS);
    const location_ids = {};
    locations?.map((item) => {
      location_ids[item.id] = item.name;
    });
    this.list?.flatMap((item) => {
      item._id = location_ids[item._id];
      return item;
    });

    return this.list;
  }
}

export default LocationDeliveryTime;
